import clsx from 'clsx';
import { WizardStateBlock } from '../../../components/StepperWizard/WizardStateBlock';

export interface WizardProgressProps {
  step: number;
}

export const OpenQuoteWizardProgress = ({ step }: WizardProgressProps) => {
  return (
    <div className={clsx('mb-6 grid grid-cols-2 items-end gap-1 text-xs')}>
      <WizardStateBlock
        label="Add locations & requirements"
        isActive={step >= 1}
        isCompleted={step > 1}
      />
      <WizardStateBlock
        label="Choose services"
        isActive={step >= 2}
        isCompleted={step > 2}
      />
    </div>
  );
};
